import { format } from 'date-fns';
import React, { useCallback } from 'react';
import { PictureWithFallback } from '../../sections/PictureWithFallback';
import { Content_File } from '../../../generated/spin-graphql';
import { useRouter } from 'next/router';

type Props = {
    slug: string;
    picture: Partial<Content_File>;
    nameLabel: string;
    lastMessage: string;
    date: string;
    read: boolean;
    selected?: boolean;
};

export const ConversationCard: React.FC<Props> = ({ slug, picture, nameLabel, lastMessage, date, read, selected }) => {
    const router = useRouter();

    const selectConversation = useCallback(() => {
        // hacky way of allowing users to click on the currently active conversation to refresh it
        if (router.asPath === slug) {
            router.reload();
        } else {
            router.push(`${slug}`, undefined, { shallow: true });
        }
    }, [slug, router]);
    return (
        <div className={`conversation-card${selected ? ' active' : ''}`} onClick={() => selectConversation()}>
            <div className="image-wrapper">
                <PictureWithFallback width={40} height={40} icon={picture} alt={`${nameLabel}'s profile picture`} />
            </div>
            <div className="user-info">
                <div className="username-timestamp">
                    <h2 className="username">{nameLabel}</h2>
                    <p className="timestamp">{format(new Date(date), 'MMM d, y')}</p>
                </div>
                <p className="last-message">{lastMessage}</p>
            </div>
            {!read && <div className="notification-badge" />}
        </div>
    );
};
